export default __webpack_public_path__ + "static/media/img3.1c1ba9c5.png";